import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePassForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  arrayLogin = [];
  userId: any;
  public showPassword: boolean;
  public showPassword2: boolean;
  userPermission: any;
  utp: any;
  changepassCreate=true;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService,) { }
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Change Password' && element.PCreate == false) {
          this.changepassCreate = false;
        }
       
      });
    }
    this.fetchUser();
    window.scroll(0, 0)
    this.changePassForm = this.fb.group({
      OldPswd: new FormControl('', [Validators.required, Validators.pattern('[a-zA-z0-9]*$')]),
      NewPswd: new FormControl('', [Validators.required, Validators.pattern('[a-zA-z0-9]*$')]),
      LoginName: new FormControl(''),
      LoginId: new FormControl(sessionStorage.getItem('userId')),
    })
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  fetchUser() {
    this.spinner.show()
    let payload = '';
    payload = sessionStorage.getItem('userId');
    this.umsService.getOneUsers(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.changePassForm.controls.LoginName.setValue(res.data[0][0]['LoginFullName']);
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  submit() {
    if (this.changePassForm.invalid) {
      this.changePassForm.get('OldPswd').markAsTouched();
      this.changePassForm.get('NewPswd').markAsTouched();
      return;
    } else {
      this.saveUser();
    }
  }
  
  saveUser() {
    this.spinner.show();
    this.submitpayload = this.changePassForm.value;
    this.umsService.changePswd(this.submitpayload).subscribe(res => {
      let user = sessionStorage.setItem('UserName', 'LoginName');
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.changePassForm.reset();
        this.dialogRef.afterClosed().subscribe(result => {
          this.changePassForm.controls.OldPswd.setValue('');
          this.changePassForm.controls.NewPswd.setValue('');
          this.changePassForm.controls.OldPswd.markAsUntouched();
          this.changePassForm.controls.NewPswd.markAsUntouched();
        });

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

}
